module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "travel-item"
  }, [_c('div', {
    staticClass: "travel-item__image"
  }, [_c('img', {
    attrs: {
      "src": _vm.args.image,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "travel-item__title"
  }, [_vm._v("\n        " + _vm._s(_vm.args.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "travel-item__description",
    domProps: {
      "innerHTML": _vm._s(_vm.args.description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "travel-item__description-extra",
    domProps: {
      "innerHTML": _vm._s(_vm.args.descriptionExtra)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "travel-item__button"
  }, [_c('a', {
    staticClass: "btn btn--block btn--orange-outline",
    attrs: {
      "href": _vm.args.url
    }
  }, [_vm._v("\n            Get Discounted Rates Today\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c49ccdc2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/modals/TravelModal.vue
// module id = 79
// module chunks = 1